import { Component, Inject, OnInit } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef, MatSnackBar} from '@angular/material/snack-bar';

@Component({
  selector: 'app-snackbar-notification',
  templateUrl: './snackbar-notification.component.html',
  styleUrls: ['./snackbar-notification.component.scss'],
})
export class SnackbarNotificationComponent  implements OnInit {
  header: string;
  content: string;
  image: string;

  constructor(
    @Inject(MAT_SNACK_BAR_DATA) public data: any,
    private snackBarRef: MatSnackBarRef<MatSnackBar>,
  ) { 
    this.header = data.header;
    this.content = data.content;
    this.image = data.image;
  }

  ngOnInit() {
    setTimeout(() => {
      this.snackBarRef.dismiss();
    }, 5000);
  }

  onUserClick() {
    this.snackBarRef.dismissWithAction();
  }

}
